import { z } from 'zod';
import { arLatnPack, arPack } from './ar';
import { enPack } from './en';
import { esPack } from './es';
import { guLatnPack, guPack } from './gu';
import { hiLatnPack, hiPack } from './hi';
import { paLatnPack, paPack } from './pa';
import type { KinPack } from './types';

export type { Kin, KinKind, KinPack, KinStep, Sex, Via } from './types';
export { relate, pathKey, sexOf } from './relate';
export { segments, type Segment } from './segments';
export { addressFor, addressRole, cardAddress, LATIN_NAME, type Address, type AddressRole, type AddressWords } from './address';
export { enPack, labelFor } from './en';
export { esPack, ordinalEs } from './es';
export { guPack, guLatnPack } from './gu';
export { hiPack, hiLatnPack } from './hi';
export { paPack, paLatnPack } from './pa';
export { arPack, arLatnPack } from './ar';

/** Every word set, in picker order. */
export const KIN_PACK_IDS = ['en', 'es', 'gu', 'gu-Latn', 'hi', 'hi-Latn', 'pa', 'pa-Latn', 'ar', 'ar-Latn'] as const;
export type KinPackId = (typeof KIN_PACK_IDS)[number];
export const KinPackIdSchema = z.enum(KIN_PACK_IDS);

export const KIN_PACKS: Record<KinPackId, KinPack> = {
  en: enPack,
  es: esPack,
  gu: guPack,
  'gu-Latn': guLatnPack,
  hi: hiPack,
  'hi-Latn': hiLatnPack,
  pa: paPack,
  'pa-Latn': paLatnPack,
  ar: arPack,
  'ar-Latn': arLatnPack,
};

export function isKinPackId(id: unknown): id is KinPackId {
  return typeof id === 'string' && (KIN_PACK_IDS as readonly string[]).includes(id);
}

/** The word set for an id, or English when the id is unknown or missing. */
export function kinPack(id: string | null | undefined): KinPack {
  return isKinPackId(id) ? KIN_PACKS[id] : enPack;
}
